import React, { useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBriefcase, faCakeCandles, faChildren, faCross, faEye, faFemale, faFileAlt, faFlag, faHelmetSafety, faIdCard, faLeaf, faMicrophone, faMosque, faOm, faPrayingHands, faQrcode, faSeedling, faUser, faVolumeHigh } from '@fortawesome/free-solid-svg-icons';
import './ContactGeniousHome.css';

function ContactGeniousHome() {
   const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = authState?.user?.name || "User";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };
  
  return (
    <div className="min-h-screen flex flex-col bg-black text-blue-100 font-sans">
          <header className="sticky top-0 z-50 bg-black border-b border-blue-400 mb-4 px-4 py-2 flex items-center justify-between shadow-lg">
            <div className="text-xl lg:text-2xl font-bold text-yellow-200">
              🪪 Think5Whys Contact Genious
            </div>
    
            <div className="hidden md:flex items-center gap-3">
              {isLoggedIn ? (
                <>
                  <div className="text-xs text-left text-blue-300">{userName}</div>
                  <button
                    onClick={handleLogout}
                    className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </>
              ) : (
                <button
                  onClick={() => navigate("/login")}
                  className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                >
                  Login
                </button>
              )}
            </div>
    
            <button
              onClick={() => setIsMobileMenuOpen((s) => !s)}
              className="md:hidden w-7 h-7 flex items-center justify-center text-xl text-blue-300 bg-blue-500 rounded"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? "×" : "☰"}
            </button>
          </header>
    
          {/* MOBILE MENU */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
              {isLoggedIn ? (
                <div className="flex flex-row items-center justify-center gap-3">
                  <span className="text-blue-300 text-xs lg:text-sm whitespace-nowrap">
                    {userName}
                  </span>
                  <button
                    onClick={handleLogout}
                    className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </div>
              ) : (
                <div className="flex flex-row items-center justify-center gap-6">
                  <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                    Login
                  </Link>
                </div>
              )}
            </div>
          )}
    
          <div className="min-h-[75vh] bg-black px-4">
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious-change-profile-image" icon={faUser} text="Profile Image" />            
            <CardLink to="/contact-genious/general" icon={faIdCard} text="Basic Digital Card" />
            <CardLink to="/contact-genious/business" icon={faBriefcase} text="Business Digital Card" />
            <CardLink to="/contact-genious/student" icon={faBook} text="Student Digital Card" />
            <CardLink to="/contact-genious/blue" icon={faHelmetSafety} text="Blue Card" />
            <CardLink to="/contact-genious/farmer" icon={faSeedling} text="Farmer Card" />
            <CardLink to="/contact-genious/patriotic" icon={faFlag} text="Patriotic Digital Card" />

            {/* <CardLink to="/contact-genious-scan" icon={faQrcode} text="Scan Profile QR" /> */}
            {/* <CardLink to="/contact-genious-scan" icon={faQrcode} text="Scan" />
            <CardLink to="/contact-genious/women" icon={faIdCard} text="Women Digital Card" />
            <CardLink to="/contact-genious/children" icon={faIdCard} text="Children Digital Card" />
            <CardLink to="/contact-genious/hindu" icon={faIdCard} text="Hinduism Faith Digital Card" />
            <CardLink to="/contact-genious/muslim" icon={faIdCard} text="Muslim Faith Digital Card" />
            <CardLink to="/contact-genious/christian" icon={faIdCard} text="Christian Faith Digital Card" />
            <CardLink to="/contact-genious/sikh" icon={faIdCard} text="Sikhism Faith Digital Card" />
            <CardLink to="/contact-genious/jain" icon={faIdCard} text="Jainism Faith Digital Card" />
            <CardLink to="/contact-genious/talking" icon={faIdCard} text="Talking Digital Card" />
            <CardLink to="/contact-genious/marriage" icon={faIdCard} text="Marriage Digital Card" />
            <CardLink to="/contact-genious-scan-log" icon={faIdCard} text="My Scan Log" />
            <CardLink to="/contact-genious-scan-log" icon={faIdCard} text="Who Scanned Me" /> */}

            <CardNoLink to="" icon={faQrcode} text="Scan Profile QR" />
            <CardNoLink to="" icon={faVolumeHigh} text="Speaking Card" />
            <CardNoLink to="" icon={faFemale} text="Women Digital Card" />
            <CardNoLink to="" icon={faChildren} text="Children Digital Card" />
            <CardNoLink to="" icon={faOm} text="Hinduism Faith Digital Card" />
            <CardNoLink to="" icon={faMosque} text="Muslim Faith Digital Card" />
            <CardNoLink to="" icon={faCross} text="Christian Faith Digital Card" />
            <CardNoLink to="" icon={faPrayingHands} text="Sikhism Faith Digital Card" />
            <CardNoLink to="" icon={faLeaf} text="Jainism Faith Digital Card" />
            <CardNoLink to="" icon={faMicrophone} text="Marriage Digital Card" />
            <CardNoLink to="" icon={faCakeCandles} text="Birthday Digital Card" />
            <CardNoLink to="" icon={faMicrophone} text="Talking Digital Card" />
            <CardNoLink to="" icon={faFileAlt} text="My Scan Log" />
            <CardNoLink to="" icon={faEye} text="Who Scanned Me" />
          </div>
        </div>
        <footer className="bg-black border-t border-blue-800 text-white py-4 mt-auto">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm">
              © 2025 Think5Whys Global DeepTech Solutions.
            </div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
              <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
            </div>
          </div>
        </footer>        
      </div>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-blue-600 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105 h-12">
    <Link to={to} className="flex items-center text-sm lg:text-m text-white hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-m lg:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105 h-12">
    <Link to={to} className="flex items-center text-sm lg:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm lg:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default ContactGeniousHome;
